import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { CorrelationService } from './correlation.service';

@Injectable()
export class CorrelationInterceptor implements HttpInterceptor {
  constructor(private correlation: CorrelationService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.correlation.shouldReuse()) {
      this.correlation.resetProcess();   // gap too long → treat as new process
    }

    const currentId = this.correlation.getCurrentId();

    const cloned = currentId
      ? req.clone({ setHeaders: { 'X-Correlation-Id': currentId } })
      : req.clone();

    return next.handle(cloned).pipe(
      tap(event => {
        if (event instanceof HttpResponse) {
          const respId = event.headers.get('X-Correlation-Id');
          this.correlation.setId(respId);
        }
      })
    );
  }
}